import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"

const columns = (toggleModal,onClickDelete, user) => {
  const styles = {
    Paid: { background: "#d1fae5", color: "#065f46" },      // green
    Unpaid: { background: "#fee2e2", color: "#991b1b" },    // red
    // Overdue: { background: "#fef3c7", color: "#92400e" },   // yellow
  };
  const columns = [
    {
      dataField: "Sno",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },
    {
      dataField: "timestamp",
      text: "InvId",
      sort: true,
      editable: false,
      formatter: (cellContent, row) => {
        return (<Link to={`/invoice/${row._id}`} target="_blank">{row.timestamp}</Link>)
      }
    },
    {
      dataField: "status",
      text: "Payment Status",
      sort: true,
      // editable:false,
      formatter: (cellContent, row) => {
        return (<b style={{
          padding: "4px 12px",
          borderRadius: "9999px",
          fontSize: "12px",
          fontWeight: "600",
          ...styles[row.status ? "Paid" : "Unpaid"],
        }}>{row.status ? "paid" : "Unpaid"}</b>)
      }
    },
    
    



  ]
    // Conditionally add Pay column
  if (!user) {
    columns.push({
      dataField: "Pay",
      text: "Pay",
      editable: false,
      sort: false,
      formatter: (cellContent, row) => (
        <Button disabled={row.status} onClick={() => toggleModal(row)}>
          Pay
        </Button>
      ),
    });
    columns.push({
      dataField: "PayNumber",
      text: "Pay Number",
      editable: false,
      sort: false,
    });
    columns.push({
      dataField: "PayMethod",
      text: "Pay Method",
      editable: false,
      sort: false,
    });
    columns.push({
      dataField: "Currency",
      text: "Currency",
      editable: false,
      sort: false,
    });
    columns.push({
  dataField: "PaymentDate",
  text: "Payment Date",
  editable: false,
  sort: false,
  formatter: (cellContent, row) => {
    if (!row.PaymentDate) return "-";
    return new Date(row.PaymentDate).toLocaleDateString();
  },
});
    
  }
    columns.push({
      dataField: "actions",
      text: "Actions",
      editable:false,
      formatter: (_, row) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(row)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
            </Link>

          </div>
        </>
      ),
    },);
  


  return columns
}


columns.propTypes = {
  toggleModal: PropTypes.func,
  onClickDelete: PropTypes.func,
  user: PropTypes.bool
   
}


export default columns
